// Generated from src/main/_entity/expression/antlr/Expression.g4 by ANTLR 4.9.0-SNAPSHOT
import { ATNDeserializer } from 'antlr4ts/atn/ATNDeserializer.js';
import { FailedPredicateException } from 'antlr4ts/FailedPredicateException.js';
import { NoViableAltException } from 'antlr4ts/NoViableAltException.js';
import { Parser } from 'antlr4ts/Parser.js';
import { ParserRuleContext } from 'antlr4ts/ParserRuleContext.js';
import { ParserATNSimulator } from 'antlr4ts/atn/ParserATNSimulator.js';
import { RecognitionException } from 'antlr4ts/RecognitionException.js';
import { Token } from 'antlr4ts/Token.js';
import { VocabularyImpl } from 'antlr4ts/VocabularyImpl.js';
import * as Utils from 'antlr4ts/misc/Utils.js';
export class ExpressionParser extends Parser {
    static ATOM = 1;
    static TERM = 2;
    static NUMBER = 3;
    static PLUS = 4;
    static MINUS = 5;
    static STAR = 6;
    static SLASH = 7;
    static EQ = 8;
    static NEQ = 9;
    static LTE = 10;
    static GTE = 11;
    static LT = 12;
    static GT = 13;
    static AND = 14;
    static OR = 15;
    static NOT = 16;
    static COMMA = 17;
    static LPAREN = 18;
    static RPAREN = 19;
    static LBRACK = 20;
    static RBRACK = 21;
    static WS = 22;
    static RULE_parse = 0;
    static RULE_expression = 1;
    static RULE_logicalOrExpression = 2;
    static RULE_logicalAndExpression = 3;
    static RULE_comparisonExpression = 4;
    static RULE_additiveExpression = 5;
    static RULE_multiplicativeExpression = 6;
    static RULE_unaryExpression = 7;
    static RULE_primaryExpression = 8;
    static RULE_parenthesizedExpression = 9;
    static RULE_bracketExpression = 10;
    static RULE_atom = 11;
    static RULE_term = 12;
    static RULE_number = 13;
    // tslint:disable:no-trailing-whitespace
    static ruleNames = [
        'parse', 'expression', 'logicalOrExpression', 'logicalAndExpression',
        'comparisonExpression', 'additiveExpression', 'multiplicativeExpression',
        'unaryExpression', 'primaryExpression', 'parenthesizedExpression', 'bracketExpression',
        'atom', 'term', 'number',
    ];
    static _LITERAL_NAMES = [
        undefined, undefined, undefined, undefined, '\'+\'', '\'-\'', '\'*\'', '\'/\'',
        '\'=\'', '\'!=\'', '\'<=\'', '\'>=\'', '\'<\'', '\'>\'', '\'&&\'', '\'||\'', '\'!\'', '\',\'',
        '\'(\'', '\')\'', '\'[\'', '\']\'',
    ];
    static _SYMBOLIC_NAMES = [
        undefined, 'ATOM', 'TERM', 'NUMBER', 'PLUS', 'MINUS', 'STAR', 'SLASH',
        'EQ', 'NEQ', 'LTE', 'GTE', 'LT', 'GT', 'AND', 'OR', 'NOT', 'COMMA', 'LPAREN',
        'RPAREN', 'LBRACK', 'RBRACK', 'WS',
    ];
    static VOCABULARY = new VocabularyImpl(ExpressionParser._LITERAL_NAMES, ExpressionParser._SYMBOLIC_NAMES, []);
    // @Override
    // @NotNull
    get vocabulary() {
        return ExpressionParser.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    // @Override
    get grammarFileName() {
        return 'Expression.g4';
    }
    // @Override
    get ruleNames() {
        return ExpressionParser.ruleNames;
    }
    // @Override
    get serializedATN() {
        return ExpressionParser._serializedATN;
    }
    createFailedPredicateException(predicate, message) {
        return new FailedPredicateException(this, predicate, message);
    }
    constructor(input) {
        super(input);
        this._interp = new ParserATNSimulator(ExpressionParser._ATN, this);
    }
    // @RuleVersion(0)
    parse() {
        let _localctx = new ParseContext(this._ctx, this.state);
        this.enterRule(_localctx, 0, ExpressionParser.RULE_parse);
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 28;
                this.expression();
                this.state = 29;
                this.match(ExpressionParser.EOF);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    expression() {
        let _localctx = new ExpressionContext(this._ctx, this.state);
        this.enterRule(_localctx, 2, ExpressionParser.RULE_expression);
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 31;
                this.logicalOrExpression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    logicalOrExpression() {
        let _localctx = new LogicalOrExpressionContext(this._ctx, this.state);
        this.enterRule(_localctx, 4, ExpressionParser.RULE_logicalOrExpression);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 33;
                this.logicalAndExpression();
                this.state = 38;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === ExpressionParser.OR) {
                    {
                        {
                            this.state = 34;
                            this.match(ExpressionParser.OR);
                            this.state = 35;
                            this.logicalAndExpression();
                        }
                    }
                    this.state = 40;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    logicalAndExpression() {
        let _localctx = new LogicalAndExpressionContext(this._ctx, this.state);
        this.enterRule(_localctx, 6, ExpressionParser.RULE_logicalAndExpression);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 41;
                this.comparisonExpression();
                this.state = 46;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === ExpressionParser.AND) {
                    {
                        {
                            this.state = 42;
                            this.match(ExpressionParser.AND);
                            this.state = 43;
                            this.comparisonExpression();
                        }
                    }
                    this.state = 48;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    comparisonExpression() {
        let _localctx = new ComparisonExpressionContext(this._ctx, this.state);
        this.enterRule(_localctx, 8, ExpressionParser.RULE_comparisonExpression);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 49;
                this.additiveExpression();
                this.state = 52;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << ExpressionParser.EQ) | (1 << ExpressionParser.NEQ) | (1 << ExpressionParser.LTE) | (1 << ExpressionParser.GTE) | (1 << ExpressionParser.LT) | (1 << ExpressionParser.GT))) !== 0)) {
                    {
                        this.state = 50;
                        _la = this._input.LA(1);
                        if (!((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << ExpressionParser.EQ) | (1 << ExpressionParser.NEQ) | (1 << ExpressionParser.LTE) | (1 << ExpressionParser.GTE) | (1 << ExpressionParser.LT) | (1 << ExpressionParser.GT))) !== 0))) {
                            this._errHandler.recoverInline(this);
                        }
                        else {
                            if (this._input.LA(1) === Token.EOF) {
                                this.matchedEOF = true;
                            }
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 51;
                        this.additiveExpression();
                    }
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    additiveExpression() {
        let _localctx = new AdditiveExpressionContext(this._ctx, this.state);
        this.enterRule(_localctx, 10, ExpressionParser.RULE_additiveExpression);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 54;
                this.multiplicativeExpression();
                this.state = 59;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === ExpressionParser.PLUS || _la === ExpressionParser.MINUS) {
                    {
                        {
                            this.state = 55;
                            _la = this._input.LA(1);
                            if (!(_la === ExpressionParser.PLUS || _la === ExpressionParser.MINUS)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                if (this._input.LA(1) === Token.EOF) {
                                    this.matchedEOF = true;
                                }
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 56;
                            this.multiplicativeExpression();
                        }
                    }
                    this.state = 61;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    multiplicativeExpression() {
        let _localctx = new MultiplicativeExpressionContext(this._ctx, this.state);
        this.enterRule(_localctx, 12, ExpressionParser.RULE_multiplicativeExpression);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 62;
                this.unaryExpression();
                this.state = 67;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while (_la === ExpressionParser.STAR || _la === ExpressionParser.SLASH) {
                    {
                        {
                            this.state = 63;
                            _la = this._input.LA(1);
                            if (!(_la === ExpressionParser.STAR || _la === ExpressionParser.SLASH)) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                if (this._input.LA(1) === Token.EOF) {
                                    this.matchedEOF = true;
                                }
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                            this.state = 64;
                            this.unaryExpression();
                        }
                    }
                    this.state = 69;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    unaryExpression() {
        let _localctx = new UnaryExpressionContext(this._ctx, this.state);
        this.enterRule(_localctx, 14, ExpressionParser.RULE_unaryExpression);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 73;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while ((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << ExpressionParser.PLUS) | (1 << ExpressionParser.MINUS) | (1 << ExpressionParser.NOT))) !== 0)) {
                    {
                        {
                            this.state = 70;
                            _la = this._input.LA(1);
                            if (!((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << ExpressionParser.PLUS) | (1 << ExpressionParser.MINUS) | (1 << ExpressionParser.NOT))) !== 0))) {
                                this._errHandler.recoverInline(this);
                            }
                            else {
                                if (this._input.LA(1) === Token.EOF) {
                                    this.matchedEOF = true;
                                }
                                this._errHandler.reportMatch(this);
                                this.consume();
                            }
                        }
                    }
                    this.state = 75;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 76;
                this.primaryExpression();
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    primaryExpression() {
        let _localctx = new PrimaryExpressionContext(this._ctx, this.state);
        this.enterRule(_localctx, 16, ExpressionParser.RULE_primaryExpression);
        try {
            this.state = 83;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
                case ExpressionParser.ATOM:
                    this.enterOuterAlt(_localctx, 1);
                    {
                        this.state = 78;
                        this.atom();
                    }
                    break;
                case ExpressionParser.TERM:
                    this.enterOuterAlt(_localctx, 2);
                    {
                        this.state = 79;
                        this.term();
                    }
                    break;
                case ExpressionParser.NUMBER:
                    this.enterOuterAlt(_localctx, 3);
                    {
                        this.state = 80;
                        this.number();
                    }
                    break;
                case ExpressionParser.LPAREN:
                    this.enterOuterAlt(_localctx, 4);
                    {
                        this.state = 81;
                        this.parenthesizedExpression();
                    }
                    break;
                case ExpressionParser.LBRACK:
                    this.enterOuterAlt(_localctx, 5);
                    {
                        this.state = 82;
                        this.bracketExpression();
                    }
                    break;
                default:
                    throw new NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    parenthesizedExpression() {
        let _localctx = new ParenthesizedExpressionContext(this._ctx, this.state);
        this.enterRule(_localctx, 18, ExpressionParser.RULE_parenthesizedExpression);
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 85;
                this.match(ExpressionParser.LPAREN);
                this.state = 86;
                this.expression();
                this.state = 87;
                this.match(ExpressionParser.RPAREN);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    bracketExpression() {
        let _localctx = new BracketExpressionContext(this._ctx, this.state);
        this.enterRule(_localctx, 20, ExpressionParser.RULE_bracketExpression);
        let _la;
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 89;
                this.match(ExpressionParser.LBRACK);
                this.state = 90;
                this.expression();
                this.state = 93;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === ExpressionParser.COMMA) {
                    {
                        this.state = 91;
                        this.match(ExpressionParser.COMMA);
                        this.state = 92;
                        this.expression();
                    }
                }
                this.state = 95;
                this.match(ExpressionParser.RBRACK);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    atom() {
        let _localctx = new AtomContext(this._ctx, this.state);
        this.enterRule(_localctx, 22, ExpressionParser.RULE_atom);
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 97;
                this.match(ExpressionParser.ATOM);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    term() {
        let _localctx = new TermContext(this._ctx, this.state);
        this.enterRule(_localctx, 24, ExpressionParser.RULE_term);
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 99;
                this.match(ExpressionParser.TERM);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    // @RuleVersion(0)
    number() {
        let _localctx = new NumberContext(this._ctx, this.state);
        this.enterRule(_localctx, 26, ExpressionParser.RULE_number);
        try {
            this.enterOuterAlt(_localctx, 1);
            {
                this.state = 101;
                this.match(ExpressionParser.NUMBER);
            }
        }
        catch (re) {
            if (re instanceof RecognitionException) {
                _localctx.exception = re;
                this._errHandler.reportError(this, re);
                this._errHandler.recover(this, re);
            }
            else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return _localctx;
    }
    static _serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x03\x18j\x04\x02' +
        '\t\x02\x04\x03\t\x03\x04\x04\t\x04\x04\x05\t\x05\x04\x06\t\x06\x04\x07' +
        '\t\x07\x04\b\t\b\x04\t\t\t\x04\n\t\n\x04\v\t\v\x04\f\t\f\x04\r\t\r\x04' +
        '\x0E\t\x0E\x04\x0F\t\x0F\x03\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04' +
        '\x03\x04\x03\x04\x07\x04\'\n\x04\f\x04\x0E\x04*\v\x04\x03\x05\x03\x05' +
        '\x03\x05\x07\x05/\n\x05\f\x05\x0E\x052\v\x05\x03\x06\x03\x06\x03\x06\x05' +
        '\x067\n\x06\x03\x07\x03\x07\x03\x07\x07\x07<\n\x07\f\x07\x0E\x07?\v\x07' +
        '\x03\b\x03\b\x03\b\x07\bD\n\b\f\b\x0E\bG\v\b\x03\t\x07\tJ\n\t\f\t\x0E' +
        '\tM\v\t\x03\t\x03\t\x03\n\x03\n\x03\n\x03\n\x03\n\x05\nV\n\n\x03\v\x03' +
        '\v\x03\v\x03\v\x03\f\x03\f\x03\f\x03\f\x05\f`\n\f\x03\f\x03\f\x03\r\x03' +
        '\r\x03\x0E\x03\x0E\x03\x0F\x03\x0F\x03\x0F\x02\x02\x02\x10\x02\x02\x04' +
        '\x02\x06\x02\b\x02\n\x02\f\x02\x0E\x02\x10\x02\x12\x02\x14\x02\x16\x02' +
        '\x18\x02\x1A\x02\x1C\x02\x02\x06\x03\x02\n\x0F\x03\x02\x06\x07\x03\x02' +
        '\b\t\x04\x02\x06\x07\x12\x12\x02f\x02\x1E\x03\x02\x02\x02\x04!\x03\x02' +
        '\x02\x02\x06#\x03\x02\x02\x02\b+\x03\x02\x02\x02\n3\x03\x02\x02\x02\f' +
        '8\x03\x02\x02\x02\x0E@\x03\x02\x02\x02\x10K\x03\x02\x02\x02\x12U\x03\x02' +
        '\x02\x02\x14W\x03\x02\x02\x02\x16[\x03\x02\x02\x02\x18c\x03\x02\x02\x02' +
        '\x1Ae\x03\x02\x02\x02\x1Cg\x03\x02\x02\x02\x1E\x1F\x05\x04\x03\x02\x1F' +
        ' \x07\x02\x02\x03 \x03\x03\x02\x02\x02!"\x05\x06\x04\x02"\x05\x03\x02' +
        '\x02\x02#(\x05\b\x05\x02$%\x07\x11\x02\x02%\'\x05\b\x05\x02&$\x03\x02' +
        '\x02\x02\'*\x03\x02\x02\x02(&\x03\x02\x02\x02()\x03\x02\x02\x02)\x07\x03' +
        '\x02\x02\x02*(\x03\x02\x02\x02+0\x05\n\x06\x02,-\x07\x10\x02\x02-/\x05' +
        '\n\x06\x02.,\x03\x02\x02\x02/2\x03\x02\x02\x020.\x03\x02\x02\x0201\x03' +
        '\x02\x02\x021\t\x03\x02\x02\x0220\x03\x02\x02\x0236\x05\f\x07\x0245\t' +
        '\x02\x02\x0257\x05\f\x07\x0264\x03\x02\x02\x0267\x03\x02\x02\x027\v\x03' +
        '\x02\x02\x028=\x05\x0E\b\x029:\t\x03\x02\x02:<\x05\x0E\b\x02;9\x03\x02' +
        '\x02\x02<?\x03\x02\x02\x02=;\x03\x02\x02\x02=>\x03\x02\x02\x02>\r\x03' +
        '\x02\x02\x02?=\x03\x02\x02\x02@E\x05\x10\t\x02AB\t\x04\x02\x02BD\x05\x10' +
        '\t\x02CA\x03\x02\x02\x02DG\x03\x02\x02\x02EC\x03\x02\x02\x02EF\x03\x02' +
        '\x02\x02F\x0F\x03\x02\x02\x02GE\x03\x02\x02\x02HJ\t\x05\x02\x02IH\x03' +
        '\x02\x02\x02JM\x03\x02\x02\x02KI\x03\x02\x02\x02KL\x03\x02\x02\x02LN\x03' +
        '\x02\x02\x02MK\x03\x02\x02\x02NO\x05\x12\n\x02O\x11\x03\x02\x02\x02PV' +
        '\x05\x18\r\x02QV\x05\x1A\x0E\x02RV\x05\x1C\x0F\x02SV\x05\x14\v\x02TV\x05' +
        '\x16\f\x02UP\x03\x02\x02\x02UQ\x03\x02\x02\x02UR\x03\x02\x02\x02US\x03' +
        '\x02\x02\x02UT\x03\x02\x02\x02V\x13\x03\x02\x02\x02WX\x07\x14\x02\x02' +
        'XY\x05\x04\x03\x02YZ\x07\x15\x02\x02Z\x15\x03\x02\x02\x02[\\\x07\x16\x02' +
        '\x02\\_\x05\x04\x03\x02]^\x07\x13\x02\x02^`\x05\x04\x03\x02_]\x03\x02' +
        '\x02\x02_`\x03\x02\x02\x02`a\x03\x02\x02\x02ab\x07\x17\x02\x02b\x17\x03' +
        '\x02\x02\x02cd\x07\x03\x02\x02d\x19\x03\x02\x02\x02ef\x07\x04\x02\x02' +
        'f\x1B\x03\x02\x02\x02gh\x07\x05\x02\x02h\x1D\x03\x02\x02\x02\n(06=EKU' +
        '_';
    static __ATN;
    static get _ATN() {
        if (!ExpressionParser.__ATN) {
            ExpressionParser.__ATN = new ATNDeserializer().deserialize(Utils.toCharArray(ExpressionParser._serializedATN));
        }
        return ExpressionParser.__ATN;
    }
}
export class ParseContext extends ParserRuleContext {
    expression() {
        return this.getRuleContext(0, ExpressionContext);
    }
    EOF() {
        return this.getToken(ExpressionParser.EOF, 0);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_parse;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitParse) {
            return visitor.visitParse(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ExpressionContext extends ParserRuleContext {
    logicalOrExpression() {
        return this.getRuleContext(0, LogicalOrExpressionContext);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_expression;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitExpression) {
            return visitor.visitExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LogicalOrExpressionContext extends ParserRuleContext {
    logicalAndExpression(i) {
        if (i === undefined) {
            return this.getRuleContexts(LogicalAndExpressionContext);
        }
        else {
            return this.getRuleContext(i, LogicalAndExpressionContext);
        }
    }
    OR(i) {
        if (i === undefined) {
            return this.getTokens(ExpressionParser.OR);
        }
        else {
            return this.getToken(ExpressionParser.OR, i);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_logicalOrExpression;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLogicalOrExpression) {
            return visitor.visitLogicalOrExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class LogicalAndExpressionContext extends ParserRuleContext {
    comparisonExpression(i) {
        if (i === undefined) {
            return this.getRuleContexts(ComparisonExpressionContext);
        }
        else {
            return this.getRuleContext(i, ComparisonExpressionContext);
        }
    }
    AND(i) {
        if (i === undefined) {
            return this.getTokens(ExpressionParser.AND);
        }
        else {
            return this.getToken(ExpressionParser.AND, i);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_logicalAndExpression;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitLogicalAndExpression) {
            return visitor.visitLogicalAndExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ComparisonExpressionContext extends ParserRuleContext {
    additiveExpression(i) {
        if (i === undefined) {
            return this.getRuleContexts(AdditiveExpressionContext);
        }
        else {
            return this.getRuleContext(i, AdditiveExpressionContext);
        }
    }
    EQ() {
        return this.tryGetToken(ExpressionParser.EQ, 0);
    }
    NEQ() {
        return this.tryGetToken(ExpressionParser.NEQ, 0);
    }
    LT() {
        return this.tryGetToken(ExpressionParser.LT, 0);
    }
    LTE() {
        return this.tryGetToken(ExpressionParser.LTE, 0);
    }
    GT() {
        return this.tryGetToken(ExpressionParser.GT, 0);
    }
    GTE() {
        return this.tryGetToken(ExpressionParser.GTE, 0);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_comparisonExpression;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitComparisonExpression) {
            return visitor.visitComparisonExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AdditiveExpressionContext extends ParserRuleContext {
    multiplicativeExpression(i) {
        if (i === undefined) {
            return this.getRuleContexts(MultiplicativeExpressionContext);
        }
        else {
            return this.getRuleContext(i, MultiplicativeExpressionContext);
        }
    }
    PLUS(i) {
        if (i === undefined) {
            return this.getTokens(ExpressionParser.PLUS);
        }
        else {
            return this.getToken(ExpressionParser.PLUS, i);
        }
    }
    MINUS(i) {
        if (i === undefined) {
            return this.getTokens(ExpressionParser.MINUS);
        }
        else {
            return this.getToken(ExpressionParser.MINUS, i);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_additiveExpression;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAdditiveExpression) {
            return visitor.visitAdditiveExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class MultiplicativeExpressionContext extends ParserRuleContext {
    unaryExpression(i) {
        if (i === undefined) {
            return this.getRuleContexts(UnaryExpressionContext);
        }
        else {
            return this.getRuleContext(i, UnaryExpressionContext);
        }
    }
    STAR(i) {
        if (i === undefined) {
            return this.getTokens(ExpressionParser.STAR);
        }
        else {
            return this.getToken(ExpressionParser.STAR, i);
        }
    }
    SLASH(i) {
        if (i === undefined) {
            return this.getTokens(ExpressionParser.SLASH);
        }
        else {
            return this.getToken(ExpressionParser.SLASH, i);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_multiplicativeExpression;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitMultiplicativeExpression) {
            return visitor.visitMultiplicativeExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class UnaryExpressionContext extends ParserRuleContext {
    primaryExpression() {
        return this.getRuleContext(0, PrimaryExpressionContext);
    }
    NOT(i) {
        if (i === undefined) {
            return this.getTokens(ExpressionParser.NOT);
        }
        else {
            return this.getToken(ExpressionParser.NOT, i);
        }
    }
    PLUS(i) {
        if (i === undefined) {
            return this.getTokens(ExpressionParser.PLUS);
        }
        else {
            return this.getToken(ExpressionParser.PLUS, i);
        }
    }
    MINUS(i) {
        if (i === undefined) {
            return this.getTokens(ExpressionParser.MINUS);
        }
        else {
            return this.getToken(ExpressionParser.MINUS, i);
        }
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_unaryExpression;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitUnaryExpression) {
            return visitor.visitUnaryExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class PrimaryExpressionContext extends ParserRuleContext {
    atom() {
        return this.tryGetRuleContext(0, AtomContext);
    }
    term() {
        return this.tryGetRuleContext(0, TermContext);
    }
    number() {
        return this.tryGetRuleContext(0, NumberContext);
    }
    parenthesizedExpression() {
        return this.tryGetRuleContext(0, ParenthesizedExpressionContext);
    }
    bracketExpression() {
        return this.tryGetRuleContext(0, BracketExpressionContext);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_primaryExpression;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitPrimaryExpression) {
            return visitor.visitPrimaryExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class ParenthesizedExpressionContext extends ParserRuleContext {
    LPAREN() {
        return this.getToken(ExpressionParser.LPAREN, 0);
    }
    expression() {
        return this.getRuleContext(0, ExpressionContext);
    }
    RPAREN() {
        return this.getToken(ExpressionParser.RPAREN, 0);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_parenthesizedExpression;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitParenthesizedExpression) {
            return visitor.visitParenthesizedExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class BracketExpressionContext extends ParserRuleContext {
    LBRACK() {
        return this.getToken(ExpressionParser.LBRACK, 0);
    }
    expression(i) {
        if (i === undefined) {
            return this.getRuleContexts(ExpressionContext);
        }
        else {
            return this.getRuleContext(i, ExpressionContext);
        }
    }
    RBRACK() {
        return this.getToken(ExpressionParser.RBRACK, 0);
    }
    COMMA() {
        return this.tryGetToken(ExpressionParser.COMMA, 0);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_bracketExpression;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitBracketExpression) {
            return visitor.visitBracketExpression(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class AtomContext extends ParserRuleContext {
    ATOM() {
        return this.getToken(ExpressionParser.ATOM, 0);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_atom;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitAtom) {
            return visitor.visitAtom(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class TermContext extends ParserRuleContext {
    TERM() {
        return this.getToken(ExpressionParser.TERM, 0);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_term;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitTerm) {
            return visitor.visitTerm(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
export class NumberContext extends ParserRuleContext {
    NUMBER() {
        return this.getToken(ExpressionParser.NUMBER, 0);
    }
    constructor(parent, invokingState) {
        super(parent, invokingState);
    }
    // @Override
    get ruleIndex() {
        return ExpressionParser.RULE_number;
    }
    // @Override
    accept(visitor) {
        if (visitor.visitNumber) {
            return visitor.visitNumber(this);
        }
        else {
            return visitor.visitChildren(this);
        }
    }
}
//# sourceMappingURL=ExpressionParser.js.map